import { assignInlineVars } from "@vanilla-extract/dynamic";
import { cx } from "class-variance-authority";

import * as theme from "./ChartSwatch.css";

export interface ChartSwatchProps {
    color: string;
    ringed?: boolean;
}

export function ChartSwatch({ color, ringed = false }: ChartSwatchProps) {
    return (
        <div
            aria-hidden
            className={cx(theme.swatch, ringed && theme.ringed)}
            style={assignInlineVars({ [theme.colorVar]: color })}
        />
    );
}
